import { Input } from '@avila-tek/ui/src';
import React from 'react';

interface PriceFilterProps {
  loading: boolean;
  max: string;
  setMax: React.Dispatch<React.SetStateAction<string>>;
  setMaxPrice: React.Dispatch<React.SetStateAction<number>>;
  min: string;
  setMin: React.Dispatch<React.SetStateAction<string>>;
  setMinPrice: React.Dispatch<React.SetStateAction<number>>;
}

const MAX_PRICE = 10000;

function PriceFilter({
  loading,
  max,
  setMax,
  setMaxPrice,
  min,
  setMin,
  setMinPrice,
}: PriceFilterProps) {
  const submitPriceRange = () => {
    setMinPrice(Number(min));
    setMaxPrice(Number(max || MAX_PRICE));
  };

  const cleanPriceRange = () => {
    setMinPrice(0);
    setMaxPrice(MAX_PRICE);
    setMin(null);
    setMax(null);
  };

  return (
    <div className="w-full col-span-2">
      <div className="w-full flex flex-row items-end justify-end gap-2">
        <div className="w-2/5 text-xs">
          <Input
            type="number"
            label="Desde ($)"
            value={min === null ? 'Min' : min}
            disabled={loading}
            step={5}
            max={max}
            min={0}
            onChange={(e) => {
              e.preventDefault();
              setMin(e.target.value);
            }}
            placeholder="Min"
          />
        </div>
        <div className="w-2/5 text-xs">
          <Input
            type="number"
            label="Hasta ($)"
            value={max === null ? 'Max' : max}
            disabled={loading}
            step={5}
            min={min}
            onChange={(e) => {
              e.preventDefault();
              setMax(e.target.value);
            }}
            placeholder="Max"
          />
        </div>
        <button
          disabled={min === null && max === null}
          type="button"
          className="w-1/5 py-2 bg-purple-300 hover:bg-purple-100 text-white ease-in-out duration-150 transition-all rounded"
          onClick={(e) => {
            e.preventDefault();
            submitPriceRange();
          }}
        >
          Filtrar
        </button>
        <button
          disabled={min === null && max === null}
          type="button"
          className="w-1/5 py-2 border border-purple-300 bg-white text-purple-text-300  hover:bg-purple-100  ease-in-out duration-150 transition-all rounded"
          onClick={(e) => {
            e.preventDefault();
            cleanPriceRange();
          }}
        >
          Limpiar
        </button>
      </div>
    </div>
  );
}

export default PriceFilter;
